import { defineComponent as _defineComponent } from 'vue';
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f8f22776"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id", "value", "name", "checked"];
const _hoisted_2 = ["for"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        index: null,
        label: null,
        groupName: null,
        checkedIndex: { default: 0 }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const tab = ref(props.label);
        const onClick = () => {
            emit('click', tab.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("input", {
                    id: `TAB-${props.label}-0${props.index}`,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tab).value = $event)),
                    value: props.label,
                    type: "radio",
                    name: props.groupName,
                    class: "tab-switch",
                    checked: props.index === props.checkedIndex,
                    onClick: onClick
                }, null, 8, _hoisted_1), [
                    [_vModelRadio, tab.value]
                ]),
                _createElementVNode("label", {
                    class: "tab-label",
                    for: `TAB-${props.label}-0${props.index}`
                }, _toDisplayString(props.label), 9, _hoisted_2)
            ], 64));
        };
    }
});
